import { MainMenuCategory } from '../main-menu-category.enum';

export class CommercialInvestorDemoDiligenceNav {
  public static item = {
    title: 'main-navigation.diligence',
    testId: 'finance-nav-link',
    icon: '<img src="./assets/icons/line-icons/nav/colors/bank.svg" width="24px" height="24px">',
    themedIcon: {
      avorenewables: '<img src="./assets/images/avorenewables/icons/bank.svg" width="24px" height="24px">'
    },
    bold: true,
    type: MainMenuCategory.finance,
    children: [
      {
        title: 'main-navigation.deals',
        url: '/oes/finance/programs',
        queryParams: {
          type: 'list'
        },
        testId: 'program-nav-link',
      }
    ]
  };
}
